import { render, staticRenderFns } from "./layout-block.vue?vue&type=template&id=8b3359fc&scoped=true&"
import script from "./layout-block.vue?vue&type=script&lang=js&"
export * from "./layout-block.vue?vue&type=script&lang=js&"
import style0 from "./layout-block.vue?vue&type=style&index=0&id=8b3359fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3359fc",
  null
  
)

export default component.exports